<template>
  <v-container fluid class="pa-4 rtl">
    <!-- Header -->
    <v-card class="header-card mb-4" elevation="2">
      <div class="d-flex align-center justify-space-between flex-wrap ga-3">
        <div>
          <div class="text-h5 font-weight-bold" style="color: #4a4f55">
            البنية الآمنة والمراعية للنوع الاجتماعي
          </div>
          <div class="text-body-2 text-grey-darken-1 mt-1">
            تدقيق البنية التحتية الآمنة والميسرة والمراعية للنوع | HFAS الركيزة
            الأولى
          </div>
        </div>
        <v-btn
          prepend-icon="mdi-arrow-right"
          variant="text"
          style="color: #4a4f55"
          @click="showView('pillar-infra')"
        >
          رجوع
        </v-btn>
      </div>
    </v-card>

    <!-- KPIs -->
    <v-row class="mb-4">
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card warning">
          <div class="kpi-value">٤/٩</div>
          <div class="kpi-label">مراحيض مغلقة للنساء</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">٢/٩</div>
          <div class="kpi-label">إضاءة ليلية كافية</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">١/٩</div>
          <div class="kpi-label">وصول كامل لذوي الإعاقة</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card warning">
          <div class="kpi-value">٥٣%</div>
          <div class="kpi-label">متوسط مؤشر الوصول</div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Table -->
    <v-card class="table-card" elevation="1">
      <div class="table-header">تدقيق البنية التحتية الآمنة</div>
      <v-table class="custom-table">
        <thead>
          <tr>
            <th>المرفق</th>
            <th>مناطق انتظار للنساء</th>
            <th>مراحيض مغلقة</th>
            <th>إضاءة ليلية</th>
            <th>وصول ذوي إعاقة</th>
            <th>خصوصية SRH</th>
            <th>صناديق شكاوى</th>
            <th>مؤشر الوصول%</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in facilities" :key="item.name">
            <td class="font-weight-bold">{{ item.name }}</td>
            <td>
              <v-chip
                :color="chipColor(item.womenWaiting)"
                size="small"
                variant="flat"
                >{{ item.womenWaiting }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="chipColor(item.closedToilets)"
                size="small"
                variant="flat"
                >{{ item.closedToilets }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="chipColor(item.nightLighting)"
                size="small"
                variant="flat"
                >{{ item.nightLighting }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="chipColor(item.disabilityAccess)"
                size="small"
                variant="flat"
                >{{ item.disabilityAccess }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="chipColor(item.srhPrivacy)"
                size="small"
                variant="flat"
                >{{ item.srhPrivacy }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="chipColor(item.complaintBoxes)"
                size="small"
                variant="flat"
                >{{ item.complaintBoxes }}</v-chip
              >
            </td>
            <td class="font-weight-bold">{{ item.accessIndex }}</td>
          </tr>
        </tbody>
      </v-table>
    </v-card>
  </v-container>
</template>

<script setup>
const facilities = [
  {
    name: "مستشفى الصداقة التعليمي",
    womenWaiting: "كامل",
    closedToilets: "كامل",
    nightLighting: "لا يوجد",
    disabilityAccess: "لا يوجد",
    srhPrivacy: "كامل",
    complaintBoxes: "كامل",
    accessIndex: "40%",
  },
  {
    name: "مستشفى الأمراض النفسية",
    womenWaiting: "لا يوجد",
    closedToilets: "لا يوجد",
    nightLighting: "لا يوجد",
    disabilityAccess: "لا يوجد",
    srhPrivacy: "كامل",
    complaintBoxes: "لا يوجد",
    accessIndex: "35%",
  },
  {
    name: "مجمع الشيخ عثمان",
    womenWaiting: "كامل",
    closedToilets: "كامل",
    nightLighting: "كامل",
    disabilityAccess: "كامل",
    srhPrivacy: "كامل",
    complaintBoxes: "كامل",
    accessIndex: "53%",
  },
  {
    name: "مركز كود العثماني",
    womenWaiting: "كامل",
    closedToilets: "كامل",
    nightLighting: "كامل",
    disabilityAccess: "كامل",
    srhPrivacy: "لا يوجد",
    complaintBoxes: "لا يوجد",
    accessIndex: "65%",
  },
  {
    name: "مركز الممدارة",
    womenWaiting: "كامل",
    closedToilets: "كامل",
    nightLighting: "كامل",
    disabilityAccess: "لا يوجد",
    srhPrivacy: "كامل",
    complaintBoxes: "كامل",
    accessIndex: "70%",
  },
  {
    name: "مركز المحاريق",
    womenWaiting: "لا يوجد",
    closedToilets: "لا يوجد",
    nightLighting: "كامل",
    disabilityAccess: "لا يوجد",
    srhPrivacy: "لا يوجد",
    complaintBoxes: "لا يوجد",
    accessIndex: "45%",
  },
  {
    name: "مركز عبد القوي",
    womenWaiting: "كامل",
    closedToilets: "كامل",
    nightLighting: "كامل",
    disabilityAccess: "لا يوجد",
    srhPrivacy: "كامل",
    complaintBoxes: "لا يوجد",
    accessIndex: "72%",
  },
  {
    name: "مركز ماري ستبوس",
    womenWaiting: "لا يوجد",
    closedToilets: "لا يوجد",
    nightLighting: "لا يوجد",
    disabilityAccess: "لا يوجد",
    srhPrivacy: "كامل",
    complaintBoxes: "لا يوجد",
    accessIndex: "25%",
  },
  {
    name: "جمعية حقوق الطفل",
    womenWaiting: "كامل",
    closedToilets: "كامل",
    nightLighting: "كامل",
    disabilityAccess: "لا يوجد",
    srhPrivacy: "لا يوجد",
    complaintBoxes: "لا يوجد",
    accessIndex: "76%",
  },
];

const chipColor = (value) => (value === "كامل" ? "green" : "red");
const showView = (view) => {
  console.log("Go to:", view);
};
</script>

<style scoped>
.rtl {
  direction: rtl;
}

.header-card {
  border-right: 5px solid #4a4f55;
  border-radius: 18px;
  padding: 20px;
}

.kpi-card {
  border-radius: 18px;
  padding: 20px;
  text-align: center;
}

.kpi-value {
  font-size: 34px;
  font-weight: 800;
}

.kpi-label {
  margin-top: 6px;
  font-size: 13px;
}

.danger {
  background: #fdecea;
  color: #c0392b;
}

.warning {
  background: #fff4e5;
  color: #d4821a;
}

.table-card {
  border-radius: 18px;
  overflow: hidden;
}

.table-header {
  padding: 18px;
  font-size: 18px;
  font-weight: 700;
  color: #3a3f47;
  border-bottom: 1px solid #eee;
}

.custom-table {
  direction: rtl;
}

:deep(th) {
  font-weight: 800 !important;
  color: #3a3f47 !important;
  white-space: nowrap;
}

:deep(td) {
  font-size: 14px;
  white-space: nowrap;
}
</style>
